<template>
    <card class="card-pricing bg-gradient-default border-0 text-center mb-3"
        header-classes="bg-transparent"
        body-classes="px-lg-7"
        footer-classes="bg-transparent"
        v-if="registration">

        <registration-info :registration="registration"></registration-info>

        <div class="display-3 text-white mb-3">
            {{ registration.degree.name }}
        </div>

        <base-progress class="mb-0" type="info" :value="progress(registration)">
        </base-progress>

        <div class="text-center text-white mb-4" style="margin-top:-10px;">
            {{ progress(registration) }}% {{ $t('dashboard.done').toLowerCase() }}
        </div>

        <div class="row mb-3" v-if="registration.state.from">
            <div class="col-lg-12 text-center pb-2">
                <span class="icon icon-xs icon-shape bg-white shadow rounded-circle">
                    <i class="fas fa-calendar-alt"></i>
                </span>
                <span class="pl-2 text-sm text-white">
                    <span class="text-muted">{{ $t('common.from') }}</span> {{ date(registration.state.from) }}
                    <span class="text-muted">{{ $t('common.to').toLowerCase() }}</span> {{ date(registration.state.to) }}
                </span>
            </div>
        </div>

        <div class="mb-2 mt-4" v-if="showButtons">

            <base-button type="secondary" @click="openResources">
                {{ $t('common.resources') }}
            </base-button>

            <base-button type="secondary" @click="openIssues"
                v-if="$permissions.hasRight('dashboard.issues.read-all')"
            >
                {{ $t('common.manage-issues') }}
            </base-button>
        </div>

        <portal to="modals">
            <base-modal
                v-model="modals.resources"
                :title="$t('common.resources')"
                body-classes="py-0"
            >
                <resources :registration="registration">
                </resources>
            </base-modal>
        </portal>
    </card>
</template>

<script>
    import ModalsController from '@trax/classes/ModalsController'
    import RegistrationInfo from '../common/RegistrationInfo'
    import Resources from '../common/Resources'
    import moment from 'moment'

    export default {

        components: {
            Resources, RegistrationInfo
        },

        props: {

            registration: {
                type: Object,
            },

            showButtons: {
                type: Boolean,
                default: true
            },
        },

        data() {
            return {
                modals: new ModalsController('resources'),
                moment: moment,
            }
        },

        methods: {

            progress(registration) {
                if (registration.state.sessions_count == 0) {
                    return 0
                }
                let progress = (registration.state.completed_sessions ? registration.state.completed_sessions : 0) * 100 / registration.state.sessions_count
                return parseInt(progress)
            },

            date(date) {
                return this.moment(date).format('YYYY/MM/DD')
            },

            openResources() {
                this.modals.open('resources')
            },

            openIssues() {
                this.$router.push({ name: 'log-registration-issues',
                    params: { 
                        registrationId: this.$route.params.registrationId,
                        groupId: this.$route.params.groupId ? this.$route.params.groupId : 0,
                    }
                })
            },
        }
    }
</script>

<style scoped>

    .card-pricing >>> .progress {
        background-color: #57587D;
    }
    .card-pricing >>> .help-button {
        top: 0.7rem;
        position: absolute;
        right: 1rem;
        font-size: 1.2rem;
    }

</style>
